<!-- Szirom-váz: oldalmenü + (felső sáv, tartalom). A prototípus app-shell elrendezése. -->
<div class="sz-shell" (click)="onLayoutClick()">
  <sz-sidebar></sz-sidebar>
  <div class="sz-main">
    <sz-topbar></sz-topbar>
    <main class="sz-content">
      <router-outlet></router-outlet>
    </main>
  </div>
  <sz-bottom-nav></sz-bottom-nav>
  <!-- Hiba bejelentése dialógus: a Hibajelzés oldal és a felső sáv „?” menüje nyitja -->
  <sz-issue-report-dialog></sz-issue-report-dialog>
</div>
